import flatpickr from "flatpickr"

up.compiler('[frontend-date-picker]', (element) => {
  flatpickr(element, {
    dateFormat: 'd.m.Y',
    minDate: new Date(),
    allowInput: true
  })
  element.removeAttribute('readonly')

  element.addEventListener('keydown', function (evt) {
    if (evt.keyCode == 13) {
      element._flatpickr.close()
    }
  })
})
